export const GPU = {
  GRIDCOLUMNS_gpu_gpuWorkloadView_podList: 'GRIDCOLUMNS_gpu_gpuWorkloadView_podList',
  FILTERSEARCH_gpu_gpuWorkloadView_podList: 'FILTERSEARCH_gpu_gpuWorkloadView_podList',
};
